




import {Component, Prop, Vue} from 'vue-property-decorator';
import _ from 'lodash';

import Rap from './index.page.vue';

@Component({
  components: {
    Rap
  }
})
export default class extends Vue {
  @Prop({required: true}) name: string;

  public get dataQuery() {
    return {
      ...(this.$route.query && this.$route.query.filters) ? _.reduce(JSON.parse(<string>this.$route.query.filters), (acc: any, val: any, key: string) => {
        acc[key] = val;
        return acc;
      }, {}) : {},
      name: this.name
    };
  }
}
